<template>
    <div class="banner">
        <el-carousel trigger="click" height="540px">
            <el-carousel-item v-for="(item,index) in blist" :key="index">
              <img :src="imgBaseAddress+item.filePath"  alt="" style="width:100%;height:100%">
            </el-carousel-item>
            <!--<el-carousel-item>-->
                <!--&lt;!&ndash;<video :src="imgBaseAddress+list[1].filePath" controls="controls"></video>&ndash;&gt;-->
                <!--<img :src="imgBaseAddress+list[1].filePath" alt="" style="width:100%;height:100%">-->
            <!--</el-carousel-item>-->
        </el-carousel>
    </div>
</template>

<script>
import VedioPlayerSelf from "./VedioPlayerSelf";
export default {
    components: {VedioPlayerSelf},
    data(){
        return {
            imgBaseAddress:this.$IMG_BASE_ADDRESS,
            blist:[],
        }
    },

    methods:{
        getBanner(){
            let _this = this;
            let param = {newsType:1,count:4};
            _this.$ajax.post('/cmsNews/findCmsNewsList',param).then((res) => {
                _this.blist = res.data;
            });
        }
    },

    computed:{

    },

    created(){
        this.getBanner();
    }

}
</script>
<style lang="scss" scoped>
.banner{
  height: 540px;
  // background:url('../assets/img/banner1.png') no-repeat center;
  // background:url('../../static/img/4.0.2/banner.png') no-repeat center;
  // background-size: 100% 100%;
  color:  #fff;
  .banner-tontent{
    padding-top:140px;
    .banner-h2{
      font-size: 28px;
      position: relative;
    }
    .banner-h2::after{
      width: 140px;
      height: 2px;
      background:#fff;
      position: absolute;
      bottom: -15px;
      left: 0;
      content: '';
    }
    .banner-text{
      font-size: 18px;
    }
    .phone{
      font-size: 18px;
      margin-top: 60px;
    }
    .btn{
      width: 240px;
      height: 60px;
      line-height: 60px;
      background: #2995e9;
      border-radius: 5px;
      text-align: center;
      font-size: 20px;
      margin-top: 45px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue